import { CAFilters, CAGridRow, CAGroup, CAId, CAItem } from '@/types/model/corrective-action';
import { caOrchestrationService } from './orchestration/CAOrchestrationService';

class CorrectiveActionService {
  async getGroupedCAData(): Promise<CAGroup[]> {
    return caOrchestrationService.getGroupedCAData();
  }

  /** Flattened, one-row-per-corrective-action data for the grid view. Call after getGroupedCAData(). */
  getAllCorrectiveActionItems(): CAGridRow[] {
    return caOrchestrationService.getAllCorrectiveActionItems();
  }

  async getCorrectiveActionsForLineItem(groupId: number, lineItemId: number, subItems: CAId[]): Promise<CAItem[]> {
    return caOrchestrationService.getCorrectiveActionsForLineItem(groupId, lineItemId, subItems);
  }

  /** Applies show-closed filter to the nested group/line-item/CA tree. */
  // Good Example of Result Filtering
  filterCAGroups(groups: CAGroup[], filters: CAFilters): CAGroup[] {
    if (filters.showAll) return groups;

    const selectedStatusSet = new Set(filters.selectedStatusIds);
    const selectedValidationSet = new Set(filters.selectedValidationStatusIds);

    return groups.map(group => ({
      ...group,
      lineItems: group.lineItems?.map(li => ({
        ...li,
        subItems: li.subItems?.filter(ca =>
          selectedStatusSet.has(ca.statusId) &&
          selectedValidationSet.has(ca.validationStatusId)
        ) ?? null,
      })).filter(li => (li.subItems?.length ?? 0) > 0) ?? null,
    })).filter(group => (group.lineItems?.length ?? 0) > 0);
  }
}

export const correctiveActionService = new CorrectiveActionService();
export default correctiveActionService;
